export const BASE_API_URL = "https://stand-ai-api-v1.onrender.com";
